import React from "react";
import { Scrollbars } from "react-custom-scrollbars-2";

import { withReportsList } from "../../../shared/containers/containerReportsList";

import SavedReportsNotification from "./savedReportNotification";
import DeleteSavedReportNotification from "./deleteSavedReportNotification";
import ListSavedReports from "./listSavedReports";
import Preloader from "../../../shared/items/static/preloader";
import { states } from "./../../../reducers/queriesStates";

const ListSavedReportsWrapper = (props) => {
  const { reportsListDataState, reportsListData } = props;

  return reportsListDataState === states.READY ? (
    <Scrollbars style={{ height: "100%" }} autoHide={true}>
      <ListSavedReports reportsList={reportsListData} />

      <SavedReportsNotification />

      <DeleteSavedReportNotification />
    </Scrollbars>
  ) : (
    <div style={{ display: "flex", justifyContent: "center", padding: "30px" }}>
      <Preloader />
    </div>
  );
};

export default withReportsList(React.memo(ListSavedReportsWrapper));
